import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-error bg-gradient2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "404", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "" }, "¡Uy! La página que buscabas no existe.", -1)
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message, (char, index) => {
        return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(char), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        onClick: _ctx.goHome,
        label: "Inicio",
        class: "surface-50 border-0 p-button-rounded font-weight-bold text-900 px-5"
      }, null, 8, ["onClick"])
    ])
  ]))
}